<app-modal>
  <div class="modal-m" [formGroup]="form">
    <app-modal-content>
      <div class="header-menu">
        <div class="attachment__details">
          <app-simple-text-input
            formControlName="title"
            class="big"
          ></app-simple-text-input>
          @if (attachment()?.size) {
            <p class="default-s attachment-details__size">
              {{ attachment()?.size | appFileSize }}
            </p>
          }
        </div>
        <div class="attachment__actions">
          <button im-button class="inverted" (click)="rotate()">
            {{ 'general.rotate_a' | translate }}
          </button>
          <div class="remove-attachment-button">
            <svg-icon
              src="/assets/images/icons/icon-bin.svg"
              [applyClass]="true"
              [svgStyle]="{ 'width.px': 15 }"
              class="secondary-svg-color path rect"
              (click)="remove()"
            ></svg-icon>
          </div>
        </div>
      </div>
      <div class="attachment__image-container">
        @if (!loading) {
          <img
            [src]="imgSrc || ''"
            alt=""
            class="attachment__preview"
            [class]="'rotate-' + attachment().rotate"
          />
        }
        @if (loading) {
          <app-loading-spinner class="loading-indicator"></app-loading-spinner>
        }
      </div>
    </app-modal-content>
    <app-modal-footer>
      <div class="modal-footer">
        <button im-button class="inverted" (click)="cancel()">
          {{ 'CANCEL_A' | translate }}
        </button>
        <button im-button class="primary" (click)="save()">
          {{ 'general.save_a' | translate }}
        </button>
      </div>
    </app-modal-footer>
  </div>
</app-modal>
